const monthNames = [
  'Янв',
  'Фев',
  'Мар',
  'Апр',
  'Мая',
  'Июня',
  'Июля',
  'Авг',
  'Сен',
  'Окт',
  'Ноя',
  'Дек',
];

export const getDateLabel = (val: number) => {
  const date = new Date(val);
  const m = date.getMonth();

  // Проверка на валидность даты
  if (isNaN(date.getTime())) {
    throw new Error('Неверная дата');
  }

  return `${date.getDate()} ${monthNames[m]}`;
};
